/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { useSimpliCityImageLoader } from "cms/image/use-simplicity-image-loader";
import { isValidGuid, isString } from "cms/utils/empty-exists";
import { CmsConfig } from "cms/config";
// import { Logger } from "cms/utils/log/logger";

const SimplicitySimpleImageLoader = (props) => {

    const guid = props?.guid;
    const alt = props?.alt;
    const className = props?.className;
    const enableImageDebug = CmsConfig.useDebug;
    const image = useSimpliCityImageLoader(guid);
    const hasContent = isValidGuid(image?.guid);

    if (!enableImageDebug) {
        return (
            <>
                {hasContent &&
                    <img
                        className={className}
                        src={image?.url}
                        alt={alt}
                    />
                }
            </>
        );
    }

    if (enableImageDebug) {
        return (
            <>
                {hasContent &&
                    <img
                        className={className}
                        src={image?.url}
                        alt={alt}
                    />
                }
                {enableImageDebug &&
                    <details className="in-page-debug-details">
                        <summary className="in-page-debug-summary">
                            <button>Image JSON</button>
                        </summary>
                        <pre className="in-page-debug">
                            Image Guid: {isString(guid)}
                            {JSON.stringify(image, null, 2)}
                        </pre>
                    </details>
                }
            </>
        );
    }


};

export { SimplicitySimpleImageLoader };
